// TODO: refactor jQuery --> ES
import {addEventListenerIfExist} from './utils';

export default class Unicorn {
	constructor(app) {
		this.app = app;
		const self = this;

		self.search();
		self.productView();
		self.frProduct();
		self.popup();
		self.messages();
		self.cookies();
		self.findRelations();
	}


	/**
	 * Search
	 *
	 * Remove no results message if there are results in the async variant search.
	 */
	search() {
		addEventListenerIfExist('load', function () {
			console.debug('loaded js-search-variant', this);
			const msg = document.querySelector('.js-no-results-msg');
			if (msg !== null && this.innerHTML.trim() !== '') {
				console.debug('Remove no result message')
				msg.remove();
			}
		}, '.js-search-variant');
	}

	/**
	 * product_view sidebar
	 */
	productView() {
		let self = this;

		$('.js-produktpreview-gallery').photoSwipe('.js-produktpreview-gallery-item', {
			closeOnScroll: false,
			allowUserZoom: true
		});

		if ($('.js-produktpreview-gallery').children().length <= 1) {
			// don't init swiper if we only have one or less images
			return;
		}

		var galleryThumbs = new Swiper('.js-produktpreview-swiper-thumbs', {
			spaceBetween: 10,
			slidesPerView: 3,
			// freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			navigation: {
				nextEl: '.js-thumbs-slide-next',
				prevEl: '.js-thumbs-slide-prev',
			},
		});

		var galleryTop = new Swiper('.js-produktpreview-swiper', {
			wrapperClass: 'js-produktpreview-gallery',
			slideClass: 'js-produktpreview-gallery-item',
			slideActiveClass: 'is-active',
			slideVisibleClass: 'is-active',
			loop: true,
			thumbs: {
				swiper: galleryThumbs,
			},
		});

		// Change slide on hover
		$('.js-produktpreview-swiper-thumbs .js-produktpreview-gallery-item').hover(function () {
			let idx = $('.js-produktpreview-swiper-thumbs .js-produktpreview-gallery-item').index(this) + 1; // first slide := 1
			galleryTop.slideTo(idx);
		})
	}


	/**
	 * fr product actions
	 */
	frProduct() {
		$(".js-varianten-button").on("click", function () {
			$(".lagerware-button").click()
		});

		$(".js-varianten-gruppen-button").on("click", function () {
			$(".individuell-button").click()
		});
	}

	/**
	 * popups
	 */
	popup() {
		$('body').on('click', '.js-popup-overlay ', function () {
			$('.js-popup').removeClass('is-active');
			$('.js-popup-overlay').removeClass("is-active");
		});

		$('body').on('click', '.js-popup .js-close', function () {
			$(this).closest('.js-popup').removeClass('is-active');
			if (!$('.js-popup.is-active').length) {
				// there is no popup visible
				$('.js-popup-overlay').removeClass('is-active');
			}
		});

		$('body').on('click', '[data-alert]', function () {
			let target = $(this).data('alert');
			$(target).addClass('is-active');
			$('.js-popup-overlay').addClass("is-active");
		});
	}

	/**
	 * Messages
	 * Expand messages on doubleclick
	 */
	messages() {
		$(document).on('click', '.msg.msg--compact', (e) => {
			if (e.detail === 2) { // double click
				$(e.currentTarget).toggleClass('is-expanded');
			}
		})
	}

	cookies() {
		const self = this;

		/**
		 * Parse the `data-cookies` attribute of a container-
		 * @param {HTMLElement} container The `.js-cookie-extra-inquiry` node.
		 * @return {string[]} An array of the cookie names.
		 */
		const getCookies = container => container.dataset.cookies.split(',').map(s => s.trim());

		/**
		 * Check if all cookies of this extra inquiry are consented.
		 * The remove it from the DOM, otherwise activate it.
		 * @param {Array<string>} allowedCookies The current cookie consent.
		 */
		function checkConsent(allowedCookies) {
			document.querySelectorAll('.js-cookie-extra-inquiry').forEach(container => {
				if (getCookies(container).every(name => allowedCookies.includes(name))) {
					container.remove();
				} else {
					container.classList.add('is-active');
				}
			})
		}

		if (app.cookieManager === undefined) { // cookieManager not initiated, let's wait for it
			document.addEventListener('cookie-manager-ready', e => checkConsent(e.detail.allowedCookies));
			document.addEventListener('cookie-manager-consent-change', e => checkConsent(e.detail.allowedCookies));
		} else {
			checkConsent(app.cookieManager.allowedCookies)
		}

		document.addEventListener('click', e => {
			if (e.target.classList.contains('btn')) {
				const container = e.target.closest('.js-cookie-extra-inquiry');
				if (container !== null) {
					e.preventDefault();
					self.app.cookieManager.allowCookie(...getCookies(container));
					container.remove();
				}
			}
		})
	}

	/**
	 * Admin-tool: find relations of a file.
	 */
	findRelations() {
		const dlKeyRe = /^http[s]?:\/\/(?:[\w.:-])+\/file\/(?:download|view)\/([\w\-=]+)[\/\w\s.\-_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]*$/;
		const dlKeyRe1 = /^http[s]?:\/\/(?:[\w.:-])+\.googleusercontent\.com\/([\w\-]+)(?:=s[\d]+)?$/;

		const contentNode = document.querySelector('.js-findRelations');
		if (contentNode === null)
			return;
		const basePath = contentNode.dataset.basepath;

		addEventListenerIfExist('click', (e) => {
			let url = decodeURI(document.querySelector('.js-findRelations-url-input').value);
			let parsed = url.match(dlKeyRe);
			console.debug(url);
			console.debug(parsed);

			if (parsed === null) {
				console.error('Failed to parse as file/download url');
				parsed = url.match(dlKeyRe1);
				console.debug(parsed);
			}
			if (parsed === null) {
				alert('URL konnte nicht geparsed werden');
			} else {
				document.querySelector('.js-findRelations-dlkey-input').value = parsed[1];
			}
		}, '.js-findRelations-url-button');

		addEventListenerIfExist('click', (e) => {
			window.location.href = `${basePath}/${document.querySelector('.js-findRelations-dlkey-input').value}`;
		}, '.js-findRelations-dlkey-btn');
	}
}
